import { render, staticRenderFns } from "./editorDialog.vue?vue&type=template&id=648740a4&scoped=true&"
import script from "./editorDialog.vue?vue&type=script&lang=js&"
export * from "./editorDialog.vue?vue&type=script&lang=js&"
import style0 from "./editorDialog.vue?vue&type=style&index=0&id=648740a4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648740a4",
  null
  
)

export default component.exports